import { GoToNotificationSettingsCTA } from "./ctas";
export var NotificationsIA = function NotificationsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return NOTIFICATIONS_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [NOTIFICATIONS_DESCRIPTION(strictLocalize)];
    }
  };
};
var NOTIFICATIONS_TITLE = function NOTIFICATIONS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "N8eadn",
    defaultMessage: [{
      "type": 0,
      "value": "Gérer les notifications par e-mail"
    }]
  });
};
var NOTIFICATIONS_DESCRIPTION = function NOTIFICATIONS_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "pS/Jig",
    defaultMessage: [{
      "type": 0,
      "value": "Vous avez la possibilité de sélectionner les e-mails que vous souhaitez et ne souhaitez pas recevoir dans l'onglet Notifications, sur la page Paramètres du compte. Pour plus d'informations, consultez l'article ci-dessous ou contactez-nous en utilisant l'une des options ci-dessous."
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToNotificationSettingsCTA(strictLocalize);
};